<div hidden btlToggleBodyClass [toggleCondition]="!isLoading"></div>
@if (isLoading) {
    <section class="hero is-light">
        <div class="hero-body">
            <div class="container has-text-centered is-fluid">
                <button class="button is-white is-static is-loading">En cours</button>
            </div>
        </div>
    </section>
}
<btl-cms-block [blockId]="blockId" (contentIsLoaded)="contentLoad($event)"></btl-cms-block>
